import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { HomePage, VagaPage } from 'pages';
import { constantesActions } from 'store/ducks';

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(constantesActions.buscarConstantes());
  }, []);

  return (
    <Switch>
      <Route exact path="/" component={HomePage} />
      <Route path="/vaga/:id" component={VagaPage} />
    </Switch>
  );
}

export default App;
